import React from 'react';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { IntlProvider } from 'react-intl';
import flatten from 'flat';
import LandingPageComponent from './components/LandingPageComponent';
import { messagesEN } from '../src/lib/intl/en-US';
import { CustomTextWrapper } from './components/CustomTextWrapper';

const App = () => {

    return (
        <IntlProvider locale="en" key="en" messages={flatten(messagesEN)} textComponent={CustomTextWrapper}>
            <LandingPageComponent />
        </IntlProvider>
    );
}

export default App;
